import React from 'react';
import _noop from 'lodash/noop';


export default function withAriaTabs(WarppedComponent) {

    if (!isEnableOnlineARIA) return WarppedComponent;

    const ariaTabsCls = `ol-aria-${Math.random() * 10000 | 0}`;

    // eslint-disable-next-line no-unused-vars
    class AriaTabs extends React.Component {
        constructor(props) {
            super(props);

            this.destoryHooks = [];
        }

        addElementEventListener(element, type, callback, options = {}) {
            element.addEventListener(type, callback, options);
            this.destoryHooks.push(() => {
                element.removeEventListener(type, callback, options);
            });
        }

        resetDefaultTabindex = () => {
            // eslint-disable-next-line react/no-find-dom-node
            let tabEle = document.getElementsByClassName(ariaTabsCls);
            if (tabEle.length) tabEle = tabEle[0];
            try {

                setTimeout(() => {
                    tabEle.querySelectorAll('[role="tabpanel"]').forEach(el => {
                        el.setAttribute('tabindex', -1);
                    });
                }, 0);

                tabEle.querySelectorAll('.ant-tabs-tabpane').forEach(el => {
                    el.setAttribute('tabindex', 0);
                });

                // enable all tabindex in the active tab
                tabEle.querySelectorAll('[role="tabpanel"].ant-tabs-tabpane-active [tabindex][role=button]').forEach(el => {
                    el.setAttribute('tabindex', 0);
                });
                // disable all tabindex in inactive tabs
                tabEle.querySelectorAll('[role="tabpanel"].ant-tabs-tabpane-inactive [tabindex][role=button]').forEach(el => {
                    el.setAttribute('tabindex', -1);
                });
            } catch(e) {
                _noop(e);
            }
        }

        componentDidMount() {
            // eslint-disable-next-line react/no-find-dom-node
            const tabEle = document.getElementsByClassName(ariaTabsCls);
            // tab respond to Space & Enter
            tabEle.length && this.addElementEventListener(tabEle[0], 'keydown', e => {
                if (e.key === ' ' || e.key === 'Enter') {
                    if (e.target.tagName != 'BUTTON' && e.target.tagName != 'INPUT') {
                        e.target.click();
                    }
                }
            });
            
            this.resetDefaultTabindex();
        }

        componentDidUpdate() {
            this.resetDefaultTabindex();
        }

        componentWillUnmount() {
            this.setState = () => { return }
            this.destoryHooks.forEach(hook => hook());
        }

        render() {

            return (
                <>
                    <WarppedComponent {...this.props} />
                </>
            );
        }
    }

    // eslint-disable-next-line react/display-name
    return (props) => {
        let cls = (props.className || '') + ' ' + ariaTabsCls;
        return (
            // <WarppedComponent {...props} className="aria" />
            <AriaTabs {...props} className={cls}/>
        );
    }
}